/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

export const carouselDotsStyle = {
  button: {
    display: "flex",
    minWidth: "0",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    padding: 0,
    boxSizing: "content-box",
    borderStyle: "solid",
    borderWidth: "0.125rem",
    borderRadius: "100%",
    borderColor: "grey.600",
    width: "0.5rem",
    height: "0.5rem",
    cursor: "pointer",
    "&:focus-visible::after": {
      content: "''",
      position: "absolute",
      width: "calc(100% + 0.5rem)",
      height: "calc(100% + 0.5rem)",
      borderWidth: "0.125rem",
      borderStyle: "solid",
      borderColor: "grey.900",
      borderRadius: "100%",
    },
  },
  activeButton: {
    backgroundColor: "common.black",
  },
  inactiveButton: {
    backgroundColor: "transparent",
  },
};
